import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { CardActionIcon } from './CardActionIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { LINK as MODE_LINK } from '../../constants/CardActionDisplayMode';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isActionConfigWithIcon = actionConfig => {
  return Boolean(actionConfig.iconName);
};
const isActionConfigWithLabel = actionConfig => {
  return Boolean(actionConfig.label);
};
const ButtonModeIconWithLabelComponent = ({
  actionConfig
}) => {
  const iconWithLabelButton = /*#__PURE__*/_jsxs(Button, {
    disabled: actionConfig.disabled,
    onClick: actionConfig.onClick,
    size: "extra-small",
    use: "tertiary-light",
    children: [/*#__PURE__*/_jsx(CardActionIcon, {
      name: actionConfig.iconName
    }), actionConfig.label]
  });
  if (actionConfig.tooltipText) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: actionConfig.tooltipText,
      children: iconWithLabelButton
    });
  } else {
    return iconWithLabelButton;
  }
};
const LinkModeIconWithLabelComponent = ({
  actionConfig,
  overrideLinkModeUse
}) => {
  const button = /*#__PURE__*/_jsxs(Button, {
    disabled: actionConfig.disabled,
    onClick: actionConfig.onClick,
    size: "extra-small",
    use: overrideLinkModeUse || 'link',
    children: [/*#__PURE__*/_jsx(CardActionIcon, {
      name: actionConfig.iconName
    }), actionConfig.label]
  });
  if (actionConfig.tooltipText) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: actionConfig.tooltipText,
      children: button
    });
  }
  return button;
};
const CardActionIconButton = ({
  actionConfig,
  mode
}) => {
  return /*#__PURE__*/_jsx(IconButton, {
    disabled: actionConfig.disabled,
    onClick: actionConfig.onClick,
    size: "extra-small",
    tooltip: actionConfig.tooltipText,
    use: mode === MODE_LINK ? 'link' : 'tertiary-light',
    children: /*#__PURE__*/_jsx(CardActionIcon, {
      name: actionConfig.iconName
    })
  });
};
const LabelButton = ({
  actionConfig,
  mode,
  overrideLinkModeUse
}) => {
  const textButton = /*#__PURE__*/_jsx(Button, {
    disabled: actionConfig.disabled,
    onClick: actionConfig.onClick,
    size: "extra-small",
    use: mode === MODE_LINK ? overrideLinkModeUse || 'link' : 'tertiary-light',
    children: actionConfig.label
  });
  if (actionConfig.tooltipText) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: actionConfig.tooltipText,
      children: textButton
    });
  } else {
    return textButton;
  }
};
export default function ButtonCardAction({
  actionConfig,
  mode,
  overrideLinkModeUse
}) {
  if (isActionConfigWithIcon(actionConfig) && isActionConfigWithLabel(actionConfig)) {
    if (mode === 'button') {
      return /*#__PURE__*/_jsx(ButtonModeIconWithLabelComponent, {
        actionConfig: actionConfig
      });
    } else {
      return /*#__PURE__*/_jsx(LinkModeIconWithLabelComponent, {
        actionConfig: actionConfig,
        overrideLinkModeUse: overrideLinkModeUse
      });
    }
  }
  if (isActionConfigWithIcon(actionConfig)) {
    return /*#__PURE__*/_jsx(CardActionIconButton, {
      actionConfig: actionConfig,
      mode: mode
    });
  }
  if (isActionConfigWithLabel(actionConfig)) {
    return /*#__PURE__*/_jsx(LabelButton, {
      actionConfig: actionConfig,
      mode: mode,
      overrideLinkModeUse: overrideLinkModeUse
    });
  }
  return null;
}